export const slidedata = [
    {
        index: 1
    },
    {
        index: 2
    },
    {
        index: 3
    },
    {
        index: 4
    },
    {
        index: 5
    },
]